
import { Injectable } from '@angular/core';

@Injectable()
export class FooterService {

  showHamburgerMenu = false;


  toggleHamburgerMenu(): void {
    this.showHamburgerMenu = !this.showHamburgerMenu;
  }

  hideHamburgerMenu(): void {
    this.showHamburgerMenu = false;
  }
}
